import { detectRuntime } from './detect-runtime'
import { getSdkMeta } from './read-sdk-meta'

export type SdkAttributes = {
  version: string
  language: string
  name: string
  agentFramework: string | null
  agentFrameworkVersion: string | null
  runtime?: string | null
  runtimeVersion?: string | null
}

export type CoreSdkAttributes = Omit<
  SdkAttributes,
  'agentFramework' | 'agentFrameworkVersion'
>

let coreSdkAttributes: CoreSdkAttributes | null = null

export function getCoreSdkAttributes(): CoreSdkAttributes {
  if (!coreSdkAttributes) {
    const { sdkName, sdkVersion } = getSdkMeta()
    const { runtime, runtimeVersion } = detectRuntime()
    coreSdkAttributes = {
      version: sdkVersion,
      language: 'js',
      name: sdkName,
      runtime,
      runtimeVersion,
    }
  }

  return coreSdkAttributes
}
